export default __webpack_public_path__ + "static/media/slider2.32bd0fdf.jpg";